// extracted by mini-css-extract-plugin
export default {"label":"SelectAccordion_label__Rs3Su","wrapSelect":"SelectAccordion_wrapSelect__fGTHF"};